<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Statement Line Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.stmtLnType }}</td>
                  <td class="text-xs-left">{{ row.item.stmtLnDesc1 }}</td>
                  <td class="text-xs-left">{{ row.item.stmtLnDesc2 }}</td>
                  <td class="text-xs-left">{{ row.item.stmtLnDesc3 }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      stmtLnType: 'stmtLnType',
      headers: [
        { text: 'Statement Line Type', value: 'stmtLnType' },
        { text: 'Description 1', value: 'stmtLnDesc1' },
        { text: 'Description 2', value: 'stmtLnDesc2' },
        { text: 'Description 3', value: 'stmtLnDesc3' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      labels: {
        stmtLnType: 'Statement Line Type',
        stmtLnDesc1: 'Description 1',
        stmtLnDesc2: 'Description 1',
        stmtLnDesc3: 'Description 1'
      },
      filters: {
        stmtLnType: undefined,
        stmtLnDesc1: undefined,
        stmtLnDesc2: undefined,
        stmtLnDesc3: undefined
      },
      loading: false,
      selectedStmtLnType: undefined,
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getCalcRateHelplist
      if (apiURI) {
        this.loading = true
        try {
          this.loading = true
          const expand = {
            fieldName: 'stmtLnType',
            riType: this.riType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((stmtLnType) => {
                const convertList = {
                  stmtLnType: stmtLnType.stmtLnType,
                  stmtLnDesc1: stmtLnType.stmtLnDesc1,
                  stmtLnDesc2: stmtLnType.stmtLnDesc2,
                  stmtLnDesc3: stmtLnType.stmtLnDesc3
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(data) {
      const stmtLnTypeObj = {
        stmtTypeOpt: this.stmtLnType,
        stmtLnType: data.stmtLnType,
        stmtLnDesc1: data.stmtLnDesc1,
        stmtLnDesc2: data.stmtLnDesc2,
        stmtLnDesc3: data.stmtLnDesc3
      }
      this.$emit('selectStmtLnType', stmtLnTypeObj)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.calcRate.menu
    }
  },
  props: {
    riType: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>

<style>
</style>
